process.env.NODE_ENV === "development" && module.hot.accept();

import "@babel/polyfill";

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import smoothscrollPolyfill from "smoothscroll-polyfill";
import smoothscrollAnchorPolyfill from "smoothscroll-anchor-polyfill"; // eslint-disable-line
import axios from "axios";
import ReactGA from "react-ga";

import Router from "router";

import store from "redux/store";

import "assets/styles/normalize.scss";
import "assets/styles/fonts.scss";
import "assets/styles/utils.scss";

smoothscrollPolyfill.polyfill();

axios.defaults.baseURL = process.env.API_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["X-Requestes-With"] = "XMLHttpRequest";

const ParlorSocialClub = () => {
  useEffect(() => {
    ReactGA.initialize("UA-55009552-2", { debug: false });
  }, []);

  return (
    <Provider store={store}>
      <Router />
    </Provider>
  );
};

ReactDOM.render(
  <ParlorSocialClub />,
  document.getElementById("parlorSocialClub")
);
